module.exports = __webpack_public_path__ + "static/media/rings-wedding.fc33a8b5.svg";